var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", [
    _c("h1", { staticClass: "adsimple-111382857" }, [
      _vm._v("Datenschutzerklärung")
    ]),
    _c(
      "h2",
      { staticClass: "adsimple-111382857", attrs: { id: "datenschutz" } },
      [_vm._v("Datenschutz")]
    ),
    _c("p", [
      _vm._v(
        "Wir haben diese Datenschutzerklärung (Fassung 21.07.2020-111382857) verfasst, um Ihnen gemäß der Vorgaben der "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679&tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Datenschutz-Grundverordnung (EU) 2016/679")]
      ),
      _vm._v(
        " zu erklären, welche Informationen wir sammeln, wie wir Daten verwenden und welche Entscheidungsmöglichkeiten Sie als Besucher dieser Webseite haben."
      )
    ]),
    _c("p", [
      _vm._v(
        "Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen, wir haben uns bei der Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie möglich zu beschreiben."
      )
    ]),
    _c(
      "h2",
      {
        staticClass: "adsimple-111382857",
        attrs: { id: "automatische-datenspeicherung" }
      },
      [_vm._v("Automatische Datenspeicherung")]
    ),
    _c("p", [
      _vm._v(
        "Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt und gespeichert, so auch auf dieser Webseite."
      )
    ]),
    _c("p", [
      _vm._v(
        "Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer auf dem diese Webseite gespeichert ist) automatisch Daten wie"
      )
    ]),
    _c("ul", { staticClass: "adsimple-111382857" }, [
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("die Adresse (URL) der aufgerufenen Webseite")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Browser und Browserversion")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("das verwendete Betriebssystem")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("die Adresse (URL) der zuvor besuchten Seite (Referrer URL)")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v(
          "den Hostname und die IP-Adresse des Geräts von welchem aus zugegriffen wird"
        )
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Datum und Uhrzeit")
      ])
    ]),
    _c("p", [_vm._v("in Dateien (Webserver-Logfiles).")]),
    _c("p", [
      _vm._v(
        "In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch gelöscht. Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden."
      )
    ]),
    _c("h2", { staticClass: "adsimple-111382857", attrs: { id: "cookies" } }, [
      _vm._v("Cookies")
    ]),
    _c("p", [
      _vm._v(
        "Unsere Webseite verwendet HTTP-Cookies, um nutzerspezifische Daten zu speichern."
      ),
      _c("br"),
      _vm._v(
        " Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden, damit Sie die folgende Datenschutzerklärung besser verstehen."
      )
    ]),
    _c("h3", { staticClass: "adsimple-111382857" }, [
      _vm._v("Was genau sind Cookies?")
    ]),
    _c("p", [
      _vm._v(
        "Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte Browser sind beispielsweise Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die meisten Webseiten speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies."
      )
    ]),
    _c("p", [
      _vm._v(
        "Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche Helferlein. Fast alle Webseiten verwenden Cookies. Genauer gesprochen sind es HTTP-Cookies, da es auch noch andere Cookies für andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von unserer Webseite auf Ihrem Computer gespeichert werden. Diese Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem “Hirn” Ihres Browsers, untergebracht. Ein Cookie besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies müssen zusätzlich ein oder mehrere Attribute angegeben werden."
      )
    ]),
    _c("p", [
      _vm._v(
        "Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise Sprache oder persönliche Seiteneinstellungen. Wenn Sie unsere Seite wieder aufrufen, übermittelt Ihr Browser die „userbezogenen“ Informationen an unsere Seite zurück. Dank der Cookies weiß unsere Webseite, wer Sie sind und bietet Ihnen die Einstellung, die Sie gewohnt sind. In einigen Browsern hat jedes Cookie eine eigene Datei, in anderen wie beispielsweise Firefox sind alle Cookies in einer einzigen Datei gespeichert."
      )
    ]),
    _c("p", [
      _vm._v(
        "Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies. Erstanbieter-Cookies werden direkt von unserer Seite erstellt, Drittanbieter-Cookies werden von Partner-Webseiten (z.B. Google Analytics) erstellt. Jedes Cookie ist individuell zu bewerten, da jedes Cookie andere Daten speichert. Auch die Ablaufzeit eines Cookies variiert von ein paar Minuten bis hin zu ein paar Jahren. Cookies sind keine Software-Programme und enthalten keine Viren, Trojaner oder andere „Schädlinge“. Cookies können auch nicht auf Informationen Ihres PCs zugreifen."
      )
    ]),
    _c("p", [_vm._v("So können zum Beispiel Cookie-Daten aussehen:")]),
    _c("p", [
      _c("strong", { staticClass: "adsimple-111382857" }, [_vm._v("Name:")]),
      _vm._v(" _ga"),
      _c("br"),
      _c("strong", { staticClass: "adsimple-111382857" }, [_vm._v("Wert:")]),
      _vm._v(" GA1.2.1326744211.152111382857-9"),
      _c("br"),
      _c("strong", { staticClass: "adsimple-111382857" }, [
        _vm._v("Verwendungszweck:")
      ]),
      _vm._v(" Unterscheidung der Webseitenbesucher"),
      _c("br"),
      _c("strong", { staticClass: "adsimple-111382857" }, [
        _vm._v("Ablaufdatum:")
      ]),
      _vm._v(" nach 2 Jahren")
    ]),
    _c("p", [
      _vm._v("Diese Mindestgrößen sollte ein Browser unterstützen können:")
    ]),
    _c("ul", { staticClass: "adsimple-111382857" }, [
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Mindestens 4096 Bytes pro Cookie")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Mindestens 50 Cookies pro Domain")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Mindestens 3000 Cookies insgesamt")
      ])
    ]),
    _c("h3", { staticClass: "adsimple-111382857" }, [
      _vm._v("Welche Arten von Cookies gibt es?")
    ]),
    _c("p", [
      _vm._v(
        "Die Frage welche Cookies wir im Speziellen verwenden, hängt von den verwendeten Diensten ab und wird in den folgenden Abschnitten der Datenschutzerklärung geklärt. An dieser Stelle möchten wir kurz auf die verschiedenen Arten von HTTP-Cookies eingehen."
      )
    ]),
    _c("p", [_vm._v("Man kann 4 Arten von Cookies unterscheiden:")]),
    _c("p", [
      _c("strong", { staticClass: "adsimple-111382857" }, [
        _vm._v("Unerlässliche Cookies"),
        _c("br")
      ]),
      _vm._v(
        "Diese Cookies sind nötig, um grundlegende Funktionen der Webseite sicherzustellen. Zum Beispiel braucht es diese Cookies, wenn ein User ein Produkt in den Warenkorb legt, dann auf anderen Seiten weitersurft und später erst zur Kasse geht. Durch diese Cookies wird der Warenkorb nicht gelöscht, selbst wenn der User sein Browserfenster schließt."
      )
    ]),
    _c("p", [
      _c("strong", { staticClass: "adsimple-111382857" }, [
        _vm._v("Zweckmäßige Cookies"),
        _c("br")
      ]),
      _vm._v(
        "Diese Cookies sammeln Infos über das Userverhalten und ob der User etwaige Fehlermeldungen bekommt. Zudem werden mithilfe dieser Cookies auch die Ladezeit und das Verhalten der Webseite bei verschiedenen Browsern gemessen."
      )
    ]),
    _c("p", [
      _c("strong", { staticClass: "adsimple-111382857" }, [
        _vm._v("Zielorientierte Cookies"),
        _c("br")
      ]),
      _vm._v(
        "Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit. Beispielsweise werden eingegebene Standorte, Schriftgrößen oder Formulardaten gespeichert."
      )
    ]),
    _c("p", [
      _c("strong", { staticClass: "adsimple-111382857" }, [
        _vm._v("Werbe-Cookies"),
        _c("br")
      ]),
      _vm._v(
        "Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu dem User individuell angepasste Werbung zu liefern. Das kann sehr praktisch, aber auch sehr nervig sein."
      )
    ]),
    _c("p", [
      _vm._v(
        "Üblicherweise werden Sie beim erstmaligen Besuch einer Webseite gefragt, welche dieser Cookiearten Sie zulassen möchten. Und natürlich wird diese Entscheidung auch in einem Cookie gespeichert."
      )
    ]),
    _c("h3", { staticClass: "adsimple-111382857" }, [
      _vm._v("Wie kann ich Cookies löschen?")
    ]),
    _c("p", [
      _vm._v(
        "Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabhängig von welchem Service oder welcher Webseite die Cookies stammen, haben Sie immer die Möglichkeit Cookies zu löschen, zu deaktivieren oder nur teilweise zuzulassen. Zum Beispiel können Sie Cookies von Drittanbietern blockieren, aber alle anderen Cookies zulassen."
      )
    ]),
    _c("p", [
      _vm._v(
        "Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert wurden, wenn Sie Cookie-Einstellungen ändern oder löschen wollen, können Sie dies in Ihren Browser-Einstellungen finden:"
      )
    ]),
    _c("p", [
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://support.google.com/chrome/answer/95647?tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Chrome: Cookies in Chrome löschen, aktivieren und verwalten")]
      )
    ]),
    _c("p", [
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Safari: Verwalten von Cookies und Websitedaten mit Safari")]
      )
    ]),
    _c("p", [
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [
          _vm._v(
            "Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben"
          )
        ]
      )
    ]),
    _c("p", [
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Internet Explorer: Löschen und Verwalten von Cookies")]
      )
    ]),
    _c("p", [
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Microsoft Edge: Löschen und Verwalten von Cookies")]
      )
    ]),
    _c("p", [
      _vm._v(
        "Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten, dass er Sie immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem einzelnen Cookie entscheiden, ob Sie das Cookie erlauben oder nicht. Die Vorgangsweise ist je nach Browser verschieden. Am besten Sie suchen die Anleitung in Google mit dem Suchbegriff “Cookies löschen Chrome” oder “Cookies deaktivieren Chrome” im Falle eines Chrome Browsers."
      )
    ]),
    _c("h3", { staticClass: "adsimple-111382857" }, [
      _vm._v("Wie sieht es mit meinem Datenschutz aus?")
    ]),
    _c("p", [
      _vm._v(
        "Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist festgehalten, dass das Speichern von Cookies eine Einwilligung von Ihnen verlangt. Innerhalb der EU-Länder gibt es allerdings noch sehr unterschiedliche Reaktionen auf diese Richtlinien. In Österreich erfolgte aber die Umsetzung dieser Richtlinie in § 96 Abs. 3 des Telekommunikationsgesetzes (TKG)."
      )
    ]),
    _c("p", [
      _vm._v(
        "Wenn Sie mehr über Cookies wissen möchten und technische Dokumentationen nicht scheuen, empfehlen wir "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href: "https://tools.ietf.org/html/rfc6265",
            target: "_blank",
            rel: "nofollow noopener noreferrer"
          }
        },
        [_vm._v("https://tools.ietf.org/html/rfc6265")]
      ),
      _vm._v(
        ", dem Request for Comments der Internet Engineering Task Force (IETF) namens “HTTP State Management Mechanism”."
      )
    ]),
    _c(
      "h2",
      {
        staticClass: "adsimple-111382857",
        attrs: { id: "speicherung-persoenlicher-daten" }
      },
      [_vm._v("Speicherung persönlicher Daten")]
    ),
    _c("p", [
      _vm._v(
        "Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der Übermittlung eines Formulars oder Kommentaren im Blog, werden von uns gemeinsam mit dem Zeitpunkt und der IP-Adresse nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben."
      )
    ]),
    _c("p", [
      _vm._v(
        "Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen Besuchern, die Kontakt ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite angebotenen Dienstleistungen und Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden."
      )
    ]),
    _c("p", [
      _vm._v(
        "Wenn Sie uns persönliche Daten per E-Mail schicken – somit abseits dieser Webseite – können wir keine sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir empfehlen Ihnen, vertrauliche Daten niemals unverschlüsselt per E-Mail zu übermitteln."
      )
    ]),
    _c(
      "h2",
      { staticClass: "adsimple-111382857", attrs: { id: "rechte-dsgvo" } },
      [_vm._v("Rechte laut Datenschutzgrundverordnung")]
    ),
    _c("p", [
      _vm._v(
        "Ihnen stehen laut den Bestimmungen der DSGVO und des österreichischen "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Datenschutzgesetzes (DSG)")]
      ),
      _vm._v(" grundsätzlich die folgende Rechte zu:")
    ]),
    _c("ul", { staticClass: "adsimple-111382857" }, [
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Recht auf Berichtigung (Artikel 16 DSGVO)")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v(
          "Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)"
        )
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v(
          "Recht auf Benachrichtigung – Mitteilungspflicht im Zusammenhang mit der Berichtigung oder Löschung personenbezogener Daten oder der Einschränkung der Verarbeitung (Artikel 19 DSGVO)"
        )
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v("Widerspruchsrecht (Artikel 21 DSGVO)")
      ]),
      _c("li", { staticClass: "adsimple-111382857" }, [
        _vm._v(
          "Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung — einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)"
        )
      ])
    ]),
    _c("p", [
      _vm._v(
        "Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren, welche in Österreich die Datenschutzbehörde ist, deren Webseite Sie unter "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: { href: "https://www.dsb.gv.at/?tid=111382857" }
        },
        [_vm._v("https://www.dsb.gv.at/")]
      ),
      _vm._v(" finden.")
    ]),
    _c(
      "h2",
      {
        staticClass: "adsimple-111382857",
        attrs: { id: "tls-verschluesselung-https" }
      },
      [_vm._v("TLS-Verschlüsselung mit https")]
    ),
    _c("p", [
      _vm._v(
        "Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch Technikgestaltung "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href:
              "https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&from=DE&tid=111382857",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("Artikel 25 Absatz 1 DSGVO")]
      ),
      _vm._v(
        "). Durch den Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol links oben im Browser und der Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse."
      )
    ]),
    _c(
      "h2",
      {
        staticClass: "adsimple-111382857",
        attrs: { id: "google-fonts-lokal-datenschutzerklaerung" }
      },
      [_vm._v("Google Fonts Lokal Datenschutzerklärung")]
    ),
    _c("p", [
      _vm._v(
        "Auf unserer Website nutzen wir Google Fonts der Firma Google Inc. Für den europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) verantwortlich. Wir haben die Google-Schriftarten lokal, d.h. auf unserem Webserver – nicht auf den Servern von Google – eingebunden. Dadurch gibt es keine Verbindung zu Google-Servern und somit auch keine Datenübertragung oder Speicherung."
      )
    ]),
    _c("h3", { staticClass: "adsimple-111382857" }, [
      _vm._v("Was sind Google Fonts?")
    ]),
    _c("p", [
      _vm._v(
        "Früher nannte man Google Fonts auch Google Web Fonts. Dabei handelt es sich um ein interaktives Verzeichnis mit über 800 Schriftarten, die "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href: "https://de.wikipedia.org/wiki/Google_LLC?tid=111382857"
          }
        },
        [_vm._v("Google")]
      ),
      _vm._v(
        " kostenlos bereitstellt. Mit Google Fonts könnte man Schriften nutzen, ohne sie auf den eigenen Server hochzuladen. Doch um diesbezüglich jede Informationsübertragung zu Google-Servern zu unterbinden, haben wir die Schriftarten auf unseren Server heruntergeladen. Auf diese Weise handeln wir datenschutzkonform und senden keine Daten an Google Fonts weiter."
      )
    ]),
    _c("p", [
      _vm._v(
        "Anders als andere Web-Schriften erlaubt uns Google uneingeschränkten Zugriff auf alle Schriftarten. Wir können also unlimitiert auf ein Meer an Schriftarten zugreifen und so das Optimum für unsere Webseite rausholen. Mehr zu Google Fonts und weiteren Fragen finden Sie auf "
      ),
      _c(
        "a",
        {
          staticClass: "adsimple-111382857",
          attrs: {
            href: "https://developers.google.com/fonts/faq?tid=111382857"
          }
        },
        [_vm._v("https://developers.google.com/fonts/faq?tid=111382857")]
      ),
      _vm._v(".")
    ]),
    _c(
      "h2",
      {
        staticClass: "adsimple-111382857",
        attrs: { id: "newsletter-datenschutzerklaerung" }
      },
      [_vm._v("Newsletter Datenschutzerklärung")]
    ),
    _c("p", [
      _c(
        "span",
        {
          staticClass: "adsimple-111382857",
          staticStyle: { "font-weight": "400" }
        },
        [
          _vm._v(
            "Wenn Sie sich für unseren Newsletter eintragen übermitteln Sie die oben genannten persönlichen Daten und geben uns das Recht Sie per E-Mail zu kontaktieren. Die im Rahmen der Anmeldung zum Newsletter gespeicherten Daten nutzen wir ausschließlich für unseren Newsletter und geben diese nicht weiter."
          )
        ]
      )
    ]),
    _c("p", [
      _c(
        "span",
        {
          staticClass: "adsimple-111382857",
          staticStyle: { "font-weight": "400" }
        },
        [
          _vm._v(
            "Sollten Sie sich vom Newsletter abmelden – Sie finden den Link dafür in jedem Newsletter ganz unten – dann löschen wir alle Daten die mit der Anmeldung zum Newsletter gespeichert wurden."
          )
        ]
      )
    ]),
    _c("p", { staticStyle: { "margin-top": "15px" } }, [
      _vm._v("Quelle: Erstellt mit dem Datenschutz Generator von "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.adsimple.at/seo-suchmaschinenoptimierung/",
            title: "AdSimple® Suchmaschinenoptimierung",
            rel: "follow noopener noreferrer",
            target: "_blank"
          }
        },
        [_vm._v("AdSimple® SEO")]
      ),
      _vm._v(" in Kooperation mit "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.meinhaushalt.at/",
            target: "_blank",
            rel: "follow noopener noreferrer"
          }
        },
        [_vm._v("meinhaushalt.at")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }